module.exports = __webpack_public_path__ + "static/img/101211.ef1e82a5.png";